import ApiService from "@/core/services/api.service";

export const FETCH_ADMIN_REPORTS_LIVES = "fetchAdminReportsLives";

export const SET_ADMIN_REPORTS_LIVES = "setAdminReportsLives";
export const SET_ADMIN_LIVES_DOWNLOAD_URL = "setAdminLivesDownloadUrl";

const state = {
  adminReportsLives: [],
  downloadUrl: null,
};

const getters = {
  adminReportsLives: (state) => state.adminReportsLives,
  adminLivesDownloadUrl: (state) => state.downloadUrl,
};

const actions = {
  async [FETCH_ADMIN_REPORTS_LIVES](context, payload = {}) {
    const params = {};
    if (payload.from) params.from = payload.from;
    if (payload.to) params.to = payload.to;
    if (payload.company) params.company = payload.company;

    try {
      const { data } = await ApiService.query("admin/admin-reports/lives", { params });
      context.commit(SET_ADMIN_REPORTS_LIVES, data.data || []);
      context.commit(SET_ADMIN_LIVES_DOWNLOAD_URL, data.download_url || null);
      return data;
    } catch (error) {
      throw error.response || error;
    }
  },
};

const mutations = {
  [SET_ADMIN_REPORTS_LIVES](state, payload) {
    state.adminReportsLives = payload;
  },
  [SET_ADMIN_LIVES_DOWNLOAD_URL](state, url) {
    state.downloadUrl = url;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
